import CallOut from '@src/ui/components/CallOut/Callout';
import CheckCircleIcon from '@src/ui/components/Icons/CheckCircleIcon';

export const CertifyDetailsCallout = () => (
    <div>
        <label className='text-xl font-bold'>By continuing, you:</label>
        <CallOut
            classes='items-center mt-4'
            icon={<CheckCircleIcon />}
            iconClasses=''
        >
            <label className='text-sm_body leading-120%'>
                Certify that the details you provided are accurate and complete
                and agree to us creating an account for your application.
            </label>
        </CallOut>
    </div>
);
